import React, { createContext, useContext, useRef, useState } from "react";

const UnsavedChangesContext = createContext(null);

export const UnsavedChangesProvider = ({ children }) => {
  const [isDirty, setIsDirty] = useState(false);
  const confirmRef = useRef(null);

  return (
    <UnsavedChangesContext.Provider
      value={{
        isDirty,
        setIsDirty,
        registerConfirm: (fn) => (confirmRef.current = fn),
        confirmIfDirty: (action) => {
          if (!isDirty || !confirmRef.current) {
            action();
          } else {
            confirmRef.current(action);
          }
        },
      }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => {
  const ctx = useContext(UnsavedChangesContext);
  if (!ctx) {
    throw new Error("useUnsavedChanges must be used inside UnsavedChangesProvider");
  }
  return ctx;
};
